const FundingSources = () => {
  const container = '#funding-pie-chart';

  const data = [
    { type: 'taxes', value: 81.4 },
    { type: 'state park fees', value: 10.8 },
    { type: 'development fees', value: 5.2 },
    { type: 'wastewater surcharge', value: 2.4 },
    // { type: 'other', value: 0.1 },
  ];

  const width = 500;
  const height = Math.min(width, 500);
  const radius = Math.min(width, height) / 2;

  const color = d3.scaleOrdinal(d3.schemeCategory10);

  const pie = d3.pie().value(d => d.value);

  const arc = d3
    .arc()
    .innerRadius(radius - 100)
    .outerRadius(radius - 20);

  const svg = d3
    .select(container)
    .append('svg')
    .attr('width', width)
    .attr('height', height)
    .style('margin-left', '8%')
    .append('g')
    .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

  const path = svg
    .datum(data)
    .selectAll('path')
    .data(pie)
    .enter()
    .append('path')
    .attr('fill', (d, i) => color(i))
    .attr('d', arc)
    .each(function (d) {
      this._current = d;
    }); // store the initial angles

  const text = svg
    .selectAll('text')
    .data(pie)
    .enter()
    .append('text')
    .attr('transform', d => `translate(${arc.centroid(d)})`)
    .attr('dy', '0.35em');

  text
    .append('tspan')
    .attr('x', '-0.4em')
    .attr('y', 0)
    .style('font-weight', 'bold')
    .style('font-size', '1.4rem')
    .style('text-align', 'center')
    .style('fill', '#FFF')
    .text(d => `${d.data.value}%`);

  const legend = d3.select(container).append('div').attr('class', 'funding-legend');

  const legendItems = d3.select('.funding-legend').selectAll('.funding-legend-item').data(data);

  legendItems.enter().append('div').attr('class', 'funding-legend-item').style('margin-top', '25px');

  d3.selectAll('.funding-legend-item')
    .append('div')
    .attr('class', 'funding-legend-rect')
    .style('width', '40px')
    .style('height', '20px')
    .style('background-color', function (d, i) {
      return color(i);
    });

  d3.selectAll('.funding-legend-item')
    .append('div')
    .attr('class', 'funding-legend-text')
    .text(d => d.type);
};

const FundingSplit = () => {
  const container = '#funding-pie-chart';

  const data = [
    { type: 'Pollution Abatement Projects', value: 60 },
    { type: 'Special Projects', value: 40 },
  ];

  const width = 500;
  const height = Math.min(width, 500);
  const radius = Math.min(width, height) / 2;

  const color = d3.scaleOrdinal(d3.schemeCategory10);

  const pie = d3.pie().value(d => d.value);

  const arc = d3
    .arc()
    .innerRadius(radius - 100)
    .outerRadius(radius - 20);

  const svg = d3
    .select(container)
    .append('svg')
    .attr('width', width)
    .attr('height', height)
    .style('margin-left', '8%')
    .append('g')
    .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

  const path = svg
    .datum(data)
    .selectAll('path')
    .data(pie)
    .enter()
    .append('path')
    .attr('fill', (d, i) => color(i))
    .attr('d', arc)
    .each(function (d) {
      this._current = d;
    }); // store the initial angles

  const text = svg
    .selectAll('text')
    .data(pie)
    .enter()
    .append('text')
    .attr('transform', d => `translate(${arc.centroid(d)})`)
    .attr('dy', '0.35em');

  text
    .append('tspan')
    .attr('x', '-0.4em')
    .attr('y', 0)
    .style('font-weight', 'bold')
    .style('font-size', '1.4rem')
    .style('text-align', 'center')
    .style('fill', '#FFF')
    .text(d => `${d.data.value}%`);

  const legend = d3.select(container).append('div').attr('class', 'funding-legend');

  const legendItems = d3.select('.funding-legend').selectAll('.funding-legend-item').data(data);

  legendItems.enter().append('div').attr('class', 'funding-legend-item').style('margin-top', '25px');

  d3.selectAll('.funding-legend-item')
    .append('div')
    .attr('class', 'funding-legend-rect')
    .style('width', '40px')
    .style('height', '20px')
    .style('background-color', function (d, i) {
      return color(i);
    });

  d3.selectAll('.funding-legend-item')
    .append('div')
    .attr('class', 'funding-legend-text')
    .text(d => d.type);
};

const CIPTable = () => {
  const CIPData = [
    {
      'Project Title':
        'Reservoir Destratification System - Distribution Preliminary Design - Includes evaluation of Optimization of Distribution with WWE Expansion Alternative',
      Total: '$2,140',
      'Authority Portion': '$2,140',
      'Proposed 2022 Budget': '$270',
      'Out-year Budget': '$1,870',
      'Funding Year(s)': '2022-2031',
    },
    {
      'Project Title': 'Reservoir Nutrient Mitigation Alternatives Study',
      Total: '$150',
      'Authority Portion': '$150',
      'Proposed 2022 Budget': '$150',
      'Out-year Budget': '$0',
      'Funding Year(s)': '2022',
    },
    {
      'Project Title': 'East Shade Shelter Shoreline Stabilization Phase III',
      Total: '$400',
      'Authority Portion': '$400',
      'Proposed 2022 Budget': '$349',
      'Out-year Budget': '$0',
      'Funding Year(s)': '2022',
    },
    {
      'Project Title': 'West Shade Shelter Shoreline Stabilization PRF',
      Total: '$704',
      'Authority Portion': '$704',
      'Proposed 2022 Budget': '$0',
      'Out-year Budget': '$550',
      'Funding Year(s)': '2019-2026',
    },
    {
      'Project Title': 'Tower Loop Shoreline Stabilization Phase II',
      Total: '$900',
      'Authority Portion': '$900',
      'Proposed 2022 Budget': '$810',
      'Out-year Budget': '$0',
      'Funding Year(s)': '2021-2022',
    },
    {
      'Project Title': 'Cherry Creek Stream Reclamation at Main Street (Parker)',
      Total: '$1,776',
      'Authority Portion': '$200',
      'Proposed 2022 Budget': '$0',
      'Out-year Budget': '$200',
      'Funding Year(s)': '2028',
    },
    {
      'Project Title': 'Cherry Creek Stream Stabilization at Lincoln Avenue (Parker)',
      Total: '$1,447',
      'Authority Portion': '$304',
      'Proposed 2022 Budget': '$0',
      'Out-year Budget': '$304',
      'Funding Year(s)': '2029',
    },
    {
      'Project Title': 'Cherry Creek Stream Reclamation - Reach 3',
      Total: '$2,567',
      'Authority Portion': '$640',
      'Proposed 2022 Budget': '$0',
      'Out-year Budget': '$640',
      'Funding Year(s)': '2023-2024',
    },
    {
      'Project Title': 'Cherry Creek Stream Reclamation - Reach 4',
      Total: '$2,720',
      'Authority Portion': '$680',
      'Proposed 2022 Budget': '$180',
      'Out-year Budget': '$475',
      'Funding Year(s)': '2021-2023',
    },
    {
      'Project Title': 'Cherry Creek Stream Reclamation - CCSP 12-mile Phase III',
      Total: '$490',
      'Authority Portion': '$490',
      'Proposed 2022 Budget': '$0',
      'Out-year Budget': '$490',
      'Funding Year(s)': '2025',
    },
    {
      'Project Title': 'Cherry Creek Stream Reclamation - CCSP 12-mile Phase IIIA',
      Total: '$550',
      'Authority Portion': '$388',
      'Proposed 2022 Budget': '$388',
      'Out-year Budget': '$0',
      'Funding Year(s)': '2021-2022',
    },
    {
      'Project Title': 'Cherry Creek Stream Reclamation - U/S Scott Road (Douglas County)',
      Total: '$2,500',
      'Authority Portion': '$625',
      'Proposed 2022 Budget': '$275',
      'Out-year Budget': '$0',
      'Funding Year(s)': '2021-2022',
    },
    {
      'Project Title': 'Cherry Creek Stream Reclamation - at Dranfeldt Extension (Parker)',
      Total: '$3,048',
      'Authority Portion': '$400',
      'Proposed 2022 Budget': '$170',
      'Out-year Budget': '$170',
      'Funding Year(s)': '2021-2022',
    },
    {
      'Project Title': 'McMurdo Gulch Reclamation (Castle Rock)',
      Total: '$4,038',
      'Authority Portion': '$1,078',
      'Proposed 2022 Budget': '$171',
      'Out-year Budget': '$907',
      'Funding Year(s)': '2020-2024',
    },
    {
      'Project Title': 'Cottonwood Creek Tributary - Shooting Area Tributary (CCSP)',
      Total: '$300',
      'Authority Portion': '$75',
      'Proposed 2022 Budget': '$0',
      'Out-year Budget': '$75',
      'Funding Year(s)': '2028',
    },
    {
      'Project Title': 'Cottonwood Creek and Tributary C (IWSD)',
      Total: '$1,664',
      'Authority Portion': '$416',
      'Proposed 2022 Budget': '$0',
      'Out-year Budget': '$416',
      'Funding Year(s)': '2031',
    },
    {
      'Project Title': 'Lone Tree Creek in CCSP (CCBWQA Only)',
      Total: '$340',
      'Authority Portion': '$340',
      'Proposed 2022 Budget': '$0',
      'Out-year Budget': '$340',
      'Funding Year(s)': '2031',
    },
    {
      'Project Title': 'Lone Tree Creek in CCSP (Centennial Trail Portion)',
      Total: '$380',
      'Authority Portion': '$95',
      'Proposed 2022 Budget': '$95',
      'Out-year Budget': '$0',
      'Funding Year(s)': '2022',
    },
    {
      'Project Title': 'Happy Canyon Creek County Line to Cherry Creek  (SEMSWA)',
      Total: '$1,520',
      'Authority Portion': '$381',
      'Proposed 2022 Budget': '$68',
      'Out-year Budget': '$288',
      'Funding Year(s)': '2021-2026',
    },
    {
      'Project Title': 'Happy Canyon Creek Upstream of I-25 (MHFD)',
      Total: '$3,943',
      'Authority Portion': '$500',
      'Proposed 2022 Budget': '$250',
      'Out-year Budget': '$0',
      'Funding Year(s)': '2021-2022',
    },
    {
      'Project Title': 'Dove Creek U/S Pond D-1 to Chambers Rd (SEMSWA)',
      Total: '$650',
      'Authority Portion': '$163',
      'Proposed 2022 Budget': '$25',
      'Out-year Budget': '$138',
      'Funding Year(s)': '2022-2024',
    },
    {
      'Project Title': 'Dove Creek Otero to Chambers Rd. (SEMSWA)',
      Total: '$700',
      'Authority Portion': '$175',
      'Proposed 2022 Budget': '$75',
      'Out-year Budget': '$75',
      'Funding Year(s)': '2021-2023',
    },
    {
      'Project Title': 'Piney Creek Reach 1 to 2 (SEMSWA)',
      Total: '$2,350',
      'Authority Portion': '$515',
      'Proposed 2022 Budget': '$38',
      'Out-year Budget': '$477',
      'Funding Year(s)': '2022-2028',
    },
    {
      'Project Title': 'Piney Creek Tower to Orchard (SEMSWA)',
      Total: '$3,000',
      'Authority Portion': '$710',
      'Proposed 2022 Budget': '$0',
      'Out-year Budget': '$710',
      'Funding Year(s)': '2024-2027',
    },
    {
      'Project Title': 'Watershed Priority Projects - Cherry and Piney Creek near CCSP',
      Total: '$0',
      'Authority Portion': '$10,980',
      'Proposed 2022 Budget': '$250',
      'Out-year Budget': '$10,730',
      'Funding Year(s)': '2022-2031',
    },
    {
      'Project Title': 'PRF Preservation, Acquisition, Lease of Land or Water',
      Total: '$500',
      'Authority Portion': '$500',
      'Proposed 2022 Budget': '$50',
      'Out-year Budget': '$450',
      'Funding Year(s)': '2022-2031',
    },
    {
      'Project Title': 'Total Capital Projects',
      Total: '$38,777',
      'Authority Portion': '$23,949',
      'Proposed 2022 Budget': '$3,614',
      'Out-year Budget': '$19,305',
      'Funding Year(s)': '',
    },
    {
      'Project Title': 'Routine',
      Total: '$422',
      'Authority Portion': '',
      'Proposed 2022 Budget': '$35',
      'Out-year Budget': '$387',
      'Funding Year(s)': '2022-2031',
    },
    {
      'Project Title': 'Operations',
      Total: '$1,715',
      'Authority Portion': '',
      'Proposed 2022 Budget': '$167',
      'Out-year Budget': '$1,548',
      'Funding Year(s)': '2022-2031',
    },
    {
      'Project Title': 'Restorative',
      Total: '$2,943',
      'Authority Portion': '',
      'Proposed 2022 Budget': '$288',
      'Out-year Budget': '$2,655',
      'Funding Year(s)': '2022-2031',
    },
    {
      'Project Title': 'Rehabilitation',
      Total: '$0',
      'Authority Portion': '',
      'Proposed 2022 Budget': '$0',
      'Out-year Budget': '$0',
      'Funding Year(s)': '2022-2031',
    },
    {
      'Project Title': 'Total Operations and Maintenance',
      Total: '$5,080',
      'Authority Portion': '',
      'Proposed 2022 Budget': '$490',
      'Out-year Budget': '$4,590',
      'Funding Year(s)': '2021-2030',
    },
  ];

  // Declare and configure request overview table
  const table = new requestTable({
    container: '#cip-table',
    filterEnabled: false,
    tableHeaders: {
      'Project Title': 'Project Title',
      Total: 'Current Total Budget',
      'Authority Portion': 'Current Authority Portion',
      'Proposed 2022 Budget': 'Proposed 2022 Budget',
      'Out-year Budget': 'Out-year Budget',
      'Funding Year(s)': 'Funding Year(s)',
    },
    tableActions: [],
    tableData: CIPData,
  });
  table.buildTable();
};
